<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="500">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small class="primary accent-4 white--text mr-2 my-1">
        {{ $t(`settings.notification.email.title`) }}
      </v-btn>
    </template>

    <notification-settings-card
      :id="id"
      :email="email"
      :subscriptions="subscriptions"
      @hide="hide"
      @refresh="$emit('refresh')"
    />
  </v-dialog>
</template>

<script>
import NotificationSettingsCard from "@/components/notification/NotificationSettingsCard.vue";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    email: {
      type: [String, null],
    },
    subscriptions: {
      type: Array,
      required: true,
    },
  },

  components: {
    NotificationSettingsCard,
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>
